export type Campaign = {
  cp_id: number;
  stl_id: string;
  info_id: number;
  category: string;
  in_date: string;
  out_date: string;
  name: string;
  version: number;
  chara_list: number[];
};
export type State = {
  loading: boolean;
  data: Campaign[];
  sound: boolean;
  reset: string[];
  version: number;
  regions: number[];
  sections: number[];
  categories: string[];
};
export const state: State = {
  loading: false,
  data: [],
  sound: false,
  reset: [],
  version: 2,
  regions: [],
  sections: [],
  categories: [],
};